import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-671c4f5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column justify-content-start align-items-center permissions-guide-container" }
const _hoisted_2 = { class: "os-content-container" }
const _hoisted_3 = {
  key: 0,
  class: "messaging-group mb-2"
}
const _hoisted_4 = { class: "icon-group" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Enable Camera & Location", -1))
const _hoisted_6 = { class: "fit-list" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createTextVNode("Select "),
  /*#__PURE__*/_createElementVNode("strong", null, "Permissions")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createTextVNode(" Enable "),
  /*#__PURE__*/_createElementVNode("strong", null, "Camera"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("strong", null, "Location")
], -1))
const _hoisted_9 = {
  key: 1,
  class: "messaging-group"
}
const _hoisted_10 = { class: "icon-group" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Enable Camera & Location", -1))
const _hoisted_12 = { class: "fit-list" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "ellipses ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-shade" }, "(", -1))
const _hoisted_15 = { class: "vertical-ellipse" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-shade" }, ")", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Settings", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Site Settings", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createTextVNode(" Click "),
  /*#__PURE__*/_createElementVNode("strong", null, "Camera"),
  /*#__PURE__*/_createTextVNode(" (or "),
  /*#__PURE__*/_createElementVNode("strong", null, "Location"),
  /*#__PURE__*/_createTextVNode(") ")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Blocked", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "TS URL ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Allow", -1))
const _hoisted_23 = {
  key: 2,
  class: "messaging-group"
}
const _hoisted_24 = { class: "icon-group" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Enable Camera & Location", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ol", { class: "fit-list" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode(" Click "),
    /*#__PURE__*/_createElementVNode("strong", null, "aA"),
    /*#__PURE__*/_createTextVNode(" in the left side of browser tool bar ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Open "),
    /*#__PURE__*/_createElementVNode("strong", null, "Website Settings")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode(" Enable "),
    /*#__PURE__*/_createElementVNode("strong", null, "Camera"),
    /*#__PURE__*/_createTextVNode(" and "),
    /*#__PURE__*/_createElementVNode("strong", null, "Location")
  ])
], -1))
const _hoisted_27 = {
  key: 3,
  class: "messaging-group"
}
const _hoisted_28 = { class: "icon-group" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Enable Location", -1))
const _hoisted_30 = { class: "my-0" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createTextVNode("Navigate to device "),
  /*#__PURE__*/_createElementVNode("strong", null, "Settings")
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Chrome", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Location", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createTextVNode(" Choose "),
  /*#__PURE__*/_createElementVNode("strong", null, "Ask Next Time Or When I Share"),
  /*#__PURE__*/_createTextVNode(" or "),
  /*#__PURE__*/_createElementVNode("strong", null, "While Using the App")
], -1))
const _hoisted_35 = { class: "icon-group" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Enable Camera", -1))
const _hoisted_37 = { class: "my-0" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createTextVNode("Navigate to device "),
  /*#__PURE__*/_createElementVNode("strong", null, "Settings")
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Chrome", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Camera", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Camera", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Toggle on", -1))
const _hoisted_43 = {
  key: 4,
  class: "default-messaging-group"
}
const _hoisted_44 = { class: "d-flex flex-column justify-content-center align-items-center exit" }
const _hoisted_45 = { class: "icon-group" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Which device are you using?", -1))
const _hoisted_47 = { class: "device-select" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-chrome" }, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-compass" }, null, -1))
const _hoisted_50 = {
  key: 5,
  class: "button-group"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgCamera = _resolveComponent("SvgCamera")!
  const _component_SvgLocation = _resolveComponent("SvgLocation")!
  const _component_ChromeSettingsIcon = _resolveComponent("ChromeSettingsIcon")!
  const _component_VerticalEllipses = _resolveComponent("VerticalEllipses")!
  const _component_ArrowIcon = _resolveComponent("ArrowIcon")!
  const _component_SvgXMark = _resolveComponent("SvgXMark")!
  const _component_AndroidIcon = _resolveComponent("AndroidIcon")!
  const _component_ZonarIcon = _resolveComponent("ZonarIcon")!
  const _component_FbxButton = _resolveComponent("FbxButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showAndroidInBrowser)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_SvgCamera, { color: "#545454" }),
              _createVNode(_component_SvgLocation, { color: "#545454" })
            ]),
            _hoisted_5,
            _createElementVNode("ol", _hoisted_6, [
              _createElementVNode("li", null, [
                _createTextVNode(" Click browser settings tooling icon "),
                _createVNode(_component_ChromeSettingsIcon, { class: "android-chrome-settings" })
              ]),
              _hoisted_7,
              _hoisted_8
            ])
          ]))
        : (_ctx.showAndroidInPwa)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_SvgCamera, { color: "#545454" }),
                _createVNode(_component_SvgLocation, { color: "#545454" })
              ]),
              _hoisted_11,
              _createElementVNode("ol", _hoisted_12, [
                _createElementVNode("li", null, [
                  _createTextVNode(" Click "),
                  _hoisted_13,
                  _hoisted_14,
                  _createElementVNode("span", _hoisted_15, [
                    _createVNode(_component_VerticalEllipses)
                  ]),
                  _hoisted_16,
                  _createTextVNode(" in Chrome browser ")
                ]),
                _createElementVNode("li", null, [
                  _createTextVNode(" Go to "),
                  _hoisted_17,
                  _createTextVNode(),
                  _createVNode(_component_ArrowIcon),
                  _hoisted_18
                ]),
                _hoisted_19,
                _createElementVNode("li", null, [
                  _createTextVNode(" Under "),
                  _hoisted_20,
                  _createTextVNode(" list, click "),
                  _hoisted_21,
                  _createTextVNode(" (" + _toDisplayString(_ctx.rootDriverURL) + ") ", 1),
                  _createVNode(_component_ArrowIcon),
                  _hoisted_22
                ])
              ])
            ]))
          : (_ctx.showIOSinSafari)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_SvgCamera, { color: "#545454" }),
                  _createVNode(_component_SvgLocation, { color: "#545454" })
                ]),
                _hoisted_25,
                _hoisted_26
              ]))
            : (_ctx.showIOSinChrome)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_SvgLocation, { color: "#545454" })
                    ]),
                    _hoisted_29,
                    _createElementVNode("ol", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("li", null, [
                        _createTextVNode(" Select "),
                        _hoisted_32,
                        _createTextVNode(),
                        _createVNode(_component_ArrowIcon),
                        _hoisted_33
                      ]),
                      _hoisted_34
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_SvgCamera, { color: "#545454" })
                    ]),
                    _hoisted_36,
                    _createElementVNode("ol", _hoisted_37, [
                      _hoisted_38,
                      _createElementVNode("li", null, [
                        _createTextVNode(" Select "),
                        _hoisted_39,
                        _createTextVNode(),
                        _createVNode(_component_ArrowIcon),
                        _hoisted_40
                      ]),
                      _createElementVNode("li", null, [
                        _createTextVNode(" Select "),
                        _hoisted_41,
                        _createTextVNode(),
                        _createVNode(_component_ArrowIcon),
                        _hoisted_42,
                        _createTextVNode(" the camera option ")
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_component_SvgXMark, {
                      color: "#545454",
                      onClick: _ctx.dismissGuide
                    }, null, 8, ["onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(_component_SvgCamera, { color: "#545454" }),
                    _createVNode(_component_SvgLocation, { color: "#545454" })
                  ]),
                  _hoisted_46,
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setMessaging('ANDROID_IN_BROWSER')))
                    }, [
                      _createVNode(_component_AndroidIcon),
                      _createTextVNode(" I'm using my browser on an Android ")
                    ]),
                    _createElementVNode("div", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setMessaging('IOS_CHROME')))
                    }, [
                      _hoisted_48,
                      _createTextVNode(" I'm using Chrome on an iPhone ")
                    ]),
                    _createElementVNode("div", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setMessaging('IOS_SAFARI')))
                    }, [
                      _hoisted_49,
                      _createTextVNode(" I'm using Safari on an iPhone ")
                    ]),
                    _createElementVNode("div", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setMessaging('ANDROID_IN_PWA')))
                    }, [
                      _createVNode(_component_ZonarIcon),
                      _createTextVNode(" I'm using my Zonar tablet ")
                    ])
                  ])
                ])),
      (!_ctx.isDefaultView)
        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
            _createVNode(_component_FbxButton, {
              theme: "primary",
              buttonText: "Got it",
              onClick: _ctx.dismissGuide
            }, null, 8, ["onClick"]),
            _createVNode(_component_FbxButton, {
              theme: "link",
              class: "italic",
              buttonText: _ctx.incorrectOSText,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setMessaging('DEFAULT')))
            }, null, 8, ["buttonText"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}